function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const PLURAL_FORMS = ['zero', 'one', 'two', 'few', 'many', 'other'];

// NOTE: Keep in sync with packages/gettext-parser/lib/utils/validate/validate-plural-form-format.js
export class PluralFactory {
  constructor(locale, pluralFormsCount) {
    _defineProperty(this, "locale", void 0);
    _defineProperty(this, "pluralRules", void 0);
    _defineProperty(this, "map", new Map());
    this.locale = locale;
    this.pluralRules = new Intl.PluralRules(locale);

    // We want to ensure a stable sorting
    // As this could be in any order, but gettext will try to keep a stable ordering from few->many
    let pluralForms = this.pluralRules.resolvedOptions().pluralCategories;
    let sortedPluralForms = PLURAL_FORMS.filter(pluralForm => pluralForms.includes(pluralForm));
    let maxMessageId = pluralFormsCount ? pluralFormsCount - 1 : sortedPluralForms.length - 1;

    // If Intl.PluralRules has more plural forms than PO, we use the last one (usually many or other) for any "higher" form
    for (let i = 0; i < sortedPluralForms.length; i++) {
      let form = sortedPluralForms[i];
      let messageId = Math.min(i, maxMessageId);
      this.map.set(form, messageId);
    }
  }
  getMessageIndex(count) {
    let pluralForm = this.pluralRules.select(count);
    return this.map.has(pluralForm) ? this.map.get(pluralForm) : 0;
  }
}